module.exports = __webpack_public_path__ + "img/funnelish-logo.da4e8ff3.svg";